import apiClient from "../../config/apiClient";

export const uploadDocument = async (id, document) => {
    const user = window.localStorage.getItem("token");
    const token = user;
    return await apiClient.post(`/public/portal?url=patient/${id}/upload-document&method=POST&token=${token}`,
        {document},
        {
        headers: {
        "Content-Type": "multipart/form-data",
        Authorization: "Bearer " + token,
        },
    });
};

// 27503 


